module.exports = __webpack_public_path__ + "static/img/bg-pt.de2794d4.png";